// src/views/Dashboard/DashboardConAnalisisJob.jsx
// /mapeo?analisisJob=<id>: vuelve a mostrar un análisis en segundo plano
// (desde el panel, el correo o el Chrome sin pantalla del worker con
// &reporte=1). Carga su contexto antes de montar el Dashboard para que este
// arranque ya con el tipo de análisis y la configuración de aquel momento.
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { Box, CircularProgress, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import Dashboard from './Dashboard';
import { aplicarSnapshotLocal, obtenerContextoJob } from '../../utils/analisisJobs';
import { instalarContadorDeRed, leerTokenReporte, reportarEstado } from './reporteAutomatico';

const DashboardConAnalisisJob = (props) => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = new URLSearchParams(location.search);
    const jobId = params.get('analisisJob');
    const modoReporte = params.get('reporte') === '1';
    const [estado, setEstado] = useState({ jobId: null, ctx: null, token: null, error: null });

    if (modoReporte) instalarContadorDeRed();

    useEffect(() => {
        if (!jobId) return undefined;
        let cancelado = false;
        (async () => {
            try {
                const token = modoReporte ? leerTokenReporte(jobId) : null;
                if (modoReporte && !token) throw new Error('Falta el token del reporte.');
                const userData = JSON.parse(localStorage.getItem('userData') || '{}');
                const ctx = await obtenerContextoJob(jobId, { idUsuario: userData?.userId, token });
                if (!ctx?.eventos?.length) throw new Error('El análisis aún no tiene resultados para mostrar.');
                aplicarSnapshotLocal(ctx.snapshot);
                if (!cancelado) setEstado({ jobId, ctx, token, error: null });
            } catch (error) {
                const mensaje = error?.response?.data?.message || error.message || 'No se pudo abrir el análisis.';
                if (modoReporte) {
                    reportarEstado('error', { mensaje });
                } else {
                    toast.error(mensaje);
                    navigate('/mapeo', { replace: true });
                }
                if (!cancelado) setEstado({ jobId, ctx: null, token: null, error: mensaje });
            }
        })();
        return () => { cancelado = true; };
    }, [jobId, modoReporte, navigate]);

    if (!jobId) return <Dashboard {...props} />;

    if (estado.jobId !== jobId || (!estado.ctx && !estado.error)) {
        return (
            <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="60vh" gap={2}>
                <CircularProgress />
                <Typography variant="body2" color="text.secondary">Cargando el análisis…</Typography>
            </Box>
        );
    }
    if (!estado.ctx) return null;

    return (
        <Dashboard
            key={jobId}
            {...props}
            replayCtx={estado.ctx}
            modoReporte={modoReporte}
            tokenReporte={estado.token}
        />
    );
};

export default DashboardConAnalisisJob;
